import React, { Component } from 'react';

class SlowConnectionBanner extends Component {
  constructor(props) {
    super(props);

    this.state = {
      errorText: this.props.errorText,
    };
  }

  componentDidUpdate(prevProps) {
    if (prevProps.errorText !== this.props.errorText) {
      this.setState({
        errorText: this.props.errorText
      });
    }
  }

  render() {
    return (
      <div className="slow-connection-notice-banner" aria-label="Connection Notice">
        <div className="slow-connection-notice-text">
          <i className="material-icons">info_outline</i>
          <span>{this.state.errorText}</span>
        </div>
      </div>
    );
  }
}

export default SlowConnectionBanner;
